export function SkipNavigation() {
    return (
        <a href="#main-content" className="skip-nav-link">
            Skip to main content
        </a>
    );
}